// **ShExWriter** writes ShEx documents.
var ShExWriter = function () {
  var util = require('util');

  var UNBOUNDED = -1; // Matches a literal as represented in memory by the ShEx library

  var ShExLiteralMatcher = /^"([^]*)"(?:\^\^(.+)|@([\-a-z]+))?$/i; // rdf:type predicate (for 'a' abbreviation)

  var RDF_PREFIX = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#',
      RDF_TYPE = RDF_PREFIX + 'type'; // Characters in literals that require escaping

  var ESCAPE_1 = /["\\\t\n\r\b\f\u0000-\u0019\ud800-\udbff]/,
      ESCAPE_g = /["\\\t\n\r\b\f\u0000-\u0019]|[\ud800-\udbff][\udc00-\udfff]/g,
      ESCAPE_replacements = {
    '\\': '\\\\',
    '"': '\\"',
    '/': '\\/',
    '\t': '\\t',
    '\n': '\\n',
    '\r': '\\r',
    '\b': '\\b',
    '\f': '\\f'
  };
  var nodeKinds = {
    'iri': "IRI",
    'bnode': "BNODE",
    'literal': "LITERAL",
    'nonliteral': "NONLITERAL"
  };
  var nonLitNodeKinds = {
    'iri': "IRI",
    'bnode': "BNODE",
    'literal': "LITERAL",
    'nonliteral': "NONLITERAL"
  }; // ## Constructor

  function ShExWriter(outputStream, options) {
    if (!(this instanceof ShExWriter)) return new ShExWriter(outputStream, options); // Shift arguments if the first argument is not a stream

    if (outputStream && typeof outputStream.write !== 'function') options = outputStream, outputStream = null;
    options = options || {}; // If no output stream given, send the output as string through the end callback

    if (!outputStream) {
      var output = '';
      this._outputStream = {
        write: function write(chunk, encoding, done) {
          output += chunk;
          done && done();
        },
        end: function end(done) {
          done && done(null, output);
        }
      };
      this._endStream = true;
    } else {
      this._outputStream = outputStream;
      this._endStream = options.end === undefined ? true : !!options.end;
    } // Initialize writer, depending on the format


    this._prefixIRIs = Object.create(null);
    options.prefixes && this.addPrefixes(options.prefixes);
    this._error = options.error || _throwError;
    this.forceParens = !options.simplifyParentheses; // default to false

    this._expect = options.lax ? noop : expect;
  }

  ShExWriter.prototype = {
    // ## Private methods
    // ### `_write` writes the argument to the output stream
    _write: function _write(string, callback) {
      this._outputStream.write(string, 'utf8', callback);
    },
    // ### `_writeSchema` writes the shape to the output stream
    _writeSchema: function _writeSchema(schema, done) {
      var _ShExWriter = this;

      this._expect(schema, "type", "Schema");

      _ShExWriter.addPrefixes(schema.prefixes);

      if (schema.base) _ShExWriter._write("BASE " + this._encodeIriOrBlankNode(schema.base) + "\n");
      if (schema.imports) schema.imports.forEach(function (imp) {
        _ShExWriter._write("IMPORT " + _ShExWriter._encodeIriOrBlankNode(imp) + "\n");
      });
      if (schema.startActs) schema.startActs.forEach(function (act) {
        _ShExWriter._expect(act, "type", "SemAct");

        _ShExWriter._write(" %" + _ShExWriter._encodePredicate(act.name) + ("code" in act ? "{" + escapeCode(act.code) + "%" + "}" : "%"));
      });
      if (schema.start) _ShExWriter._write("start = " + _ShExWriter._writeShapeExpr(schema.start, done, true, 0).join('') + "\n");
      if ("shapes" in schema) schema.shapes.forEach(function (shapeExpr) {
        var id = shapeExpr.id;
        var abstract = "";

        if (shapeExpr.type === "ShapeDecl") {
          if (shapeExpr.abstract) abstract = "abstract ";
          shapeExpr = shapeExpr.shapeExpr;
        }

        _ShExWriter._write(abstract + _ShExWriter._encodeShapeName(id, false) + " " + _ShExWriter._writeShapeExpr(shapeExpr, done, true, 0).join("") + "\n", done);
      });
    },
    _writeShapeExpr: function _writeShapeExpr(shapeExpr, done, forceBraces, parentPrec) {
      var _ShExWriter = this;

      var pieces = [];
      if (typeof shapeExpr === "string") // ShapeRef
        pieces.push("@", _ShExWriter._encodeShapeName(shapeExpr)); // !!! []s for precedence!
      else if (shapeExpr.type === "ShapeDecl") pieces.push(_ShExWriter._writeShapeExpr(shapeExpr.shapeExpr, done, false, 3));else if (shapeExpr.type === "ShapeExternal") pieces.push("EXTERNAL");else if (shapeExpr.type === "ShapeAnd") {
          if (parentPrec >= 3) pieces.push("(");
          var lastAndElided = false;
          shapeExpr.shapeExprs.forEach(function (expr, ord) {
            if (ord > 0) {
              // && !!! grammar rules too weird here

              /*
                shapeAtom:
                      nonLitNodeConstraint shapeOrRef?
                    | shapeDecl nonLitNodeConstraint?
                 nonLitInlineNodeConstraint:
                      nonLiteralKind stringFacet*
              */
              var nonLitNodeConstraint = function nonLitNodeConstraint(idx) {
                var c = shapeExpr.shapeExprs[idx];
                return c.type !== "NodeConstraint" || "nodeKind" in c && c.nodeKind === "literal" || "datatype" in c || "values" in c ? false : true;
              };

              var shapeOrRef = function shapeOrRef(idx) {
                var c = shapeExpr.shapeExprs[idx];
                return c.type === "Shape" || c.type === "ShapeRef";
              };

              var shapeDecl = function shapeDecl(idx) {
                var c = shapeExpr.shapeExprs[idx];
                return c.type === "Shape";
              };

              var elideAnd = !lastAndElided && (nonLitNodeConstraint(ord - 1) && shapeOrRef(ord) || shapeDecl(ord - 1) && nonLitNodeConstraint(ord));

              if (!elideAnd) {
                pieces.push(" AND ");
              }

              lastAndElided = elideAnd;
            }

            pieces = pieces.concat(_ShExWriter._writeShapeExpr(expr, done, false, 3));
          });
          if (parentPrec >= 3) pieces.push(")");
        } else if (shapeExpr.type === "ShapeOr") {
          if (parentPrec >= 2) pieces.push("(");
          shapeExpr.shapeExprs.forEach(function (expr, ord) {
            if (ord > 0) pieces.push(" OR ");
            pieces = pieces.concat(_ShExWriter._writeShapeExpr(expr, done, forceBraces, 2));
          });
          if (parentPrec >= 2) pieces.push(")");
        } else if (shapeExpr.type === "ShapeNot") {
          if (parentPrec >= 4) pieces.push("(");
          pieces.push("NOT ");
          pieces = pieces.concat(_ShExWriter._writeShapeExpr(shapeExpr.shapeExpr, done, forceBraces, 4));
          if (parentPrec >= 4) pieces.push(")");
        } else if (shapeExpr.type === "Shape") {
          pieces = pieces.concat(_ShExWriter._writeShape(shapeExpr, done, forceBraces));
        } else if (shapeExpr.type === "NodeConstraint") {
          pieces = pieces.concat(_ShExWriter._writeNodeConstraint(shapeExpr, done, forceBraces));
        } else throw Error("expected Shape{,And,Or,Ref} or NodeConstraint in " + util.inspect(shapeExpr));
      return pieces;
    },
    // ### `_writeShape` writes the shape to the output stream
    _writeShape: function _writeShape(shape, done, forceBraces) {
      var _ShExWriter = this;

      try {
        var _writeShapeActions = function _writeShapeActions(semActs) {
          if (!semActs) return;
          semActs.forEach(function (act) {
            _ShExWriter._expect(act, "type", "SemAct");

            pieces.push(" %", _ShExWriter._encodePredicate(act.name), "code" in act ? "{" + escapeCode(act.code) + "%" + "}" : "%");
          });
        };

        var _writeCardinality = function _writeCardinality(min, max) {
          if (min === 0 && max === 1) pieces.push("?");else if (min === 0 && max === UNBOUNDED) pieces.push("*");else if (min === undefined && max === undefined) ;else if (min === 1 && max === UNBOUNDED) pieces.push("+");else pieces.push("{", min, ",", max === UNBOUNDED ? "*" : max, "}"); // by coincidence, both use the same character.
        };

        var _writeExpression = function _writeExpression(expr, indent, parentPrecedence) {
          function _writeScopedShapeExpression(scopedShapeExpr) {
            if (scopedShapeExpr) {
              pieces.push(" ON SHAPE EXPRESSION\n");
              pieces = pieces.concat(_ShExWriter._writeShapeExpr(scopedShapeExpr, done, true, 0).map(function (line) {
                return indent + "    " + line;
              }));
            }
          }

          function _writeExpressionActions(semActs) {
            if (semActs) {
              semActs.forEach(function (act) {
                _ShExWriter._expect(act, "type", "SemAct");

                pieces.push("\n" + indent + "   %");
                pieces.push(_ShExWriter._encodeValue(act.name));
                if ("code" in act) pieces.push("{" + escapeCode(act.code) + "%" + "}");else pieces.push("%");
              });
            }
          }

          function _exprGroup(exprs, separator, precedence, forceParens) {
            var needsParens = precedence < parentPrecedence || forceParens;

            if (needsParens) {
              pieces.push("(");
            }

            exprs.forEach(function (nested, ord) {
              _writeExpression(nested, indent + "  ", precedence);

              if (ord < exprs.length - 1) pieces.push(separator);
            });

            if (needsParens) {
              pieces.push(")");
            }
          }

          if (typeof expr === "string") {
            pieces.push("&");
            pieces.push(_ShExWriter._encodeShapeName(expr, false));
          } else {
            if ("id" in expr) {
              pieces.push("$");
              pieces.push(_ShExWriter._encodeIriOrBlankNode(expr.id, true));
            }

            if (expr.type === "TripleConstraint") {
              if (expr.inverse) pieces.push("^");
              if (expr.negated) pieces.push("!");
              pieces.push(indent, _ShExWriter._encodePredicate(expr.predicate), " ");
              if ("valueExpr" in expr) pieces = pieces.concat(_ShExWriter._writeShapeExpr(expr.valueExpr, done, true, 0));else pieces.push(". ");

              _writeCardinality(expr.min, expr.max);

              _writeScopedShapeExpression(expr.onShapeExpression);

              _ShExWriter._annotations(pieces, expr.annotations, indent);

              _writeExpressionActions(expr.semActs);
            } else if (expr.type === "OneOf") {
              var needsParens = "id" in expr || "min" in expr || "max" in expr || "onShapeExpression" in expr || "annotations" in expr || "semActs" in expr;

              _exprGroup(expr.expressions, "\n" + indent + "| ", 1, needsParens || _ShExWriter.forceParens);

              _writeCardinality(expr.min, expr.max); // t: open1dotclosecardOpt


              _writeScopedShapeExpression(expr.onShapeExpression);

              _ShExWriter._annotations(pieces, expr.annotations, indent);

              _writeExpressionActions(expr.semActs);
            } else if (expr.type === "EachOf") {
              var needsParens = "id" in expr || "min" in expr || "max" in expr || "onShapeExpression" in expr || "annotations" in expr || "semActs" in expr;

              _exprGroup(expr.expressions, ";\n" + indent, 2, needsParens || _ShExWriter.forceParens);

              _writeCardinality(expr.min, expr.max); // t: open1dotclosecardOpt


              _writeScopedShapeExpression(expr.onShapeExpression);

              _ShExWriter._annotations(pieces, expr.annotations, indent);

              _writeExpressionActions(expr.semActs);
            } else throw Error("unexpected expr type: " + expr.type);
          }
        };

        var pieces = []; // guessing push/join is faster than concat

        this._expect(shape, "type", "Shape");

        if (shape.closed) pieces.push("CLOSED ");
        [{
          keyword: "extends",
          marker: "&"
        }].forEach(function (pair) {
          // pieces = pieces.concat(_ShExWriter._writeShapeExpr(expr.valueExpr, done, true, 0));
          if (shape[pair.keyword] && shape[pair.keyword].length > 0) {
            shape[pair.keyword].forEach(function (i, ord) {
              if (ord) pieces.push(" ");
              pieces.push(pair.marker);
              pieces = pieces.concat(_ShExWriter._writeShapeExpr(i, done, true, 0));
            });
            pieces.push(" ");
          }
        });

        if (shape.extra && shape.extra.length > 0) {
          pieces.push("EXTRA ");
          shape.extra.forEach(function (i, ord) {
            pieces.push(_ShExWriter._encodeShapeName(i, false) + " ");
          });
          pieces.push(" ");
        }

        var empties = ["values", "length", "minlength", "maxlength", "pattern", "flags"];
        pieces.push("{\n");
        if (shape.expression) // t: 0, 0Extend1
          _writeExpression(shape.expression, "  ", 0);
        pieces.push("\n}");

        _writeShapeActions(shape.semActs);

        _ShExWriter._annotations(pieces, shape.annotations, "  ");

        return pieces;
      } catch (error) {
        done && done(error);
      }
    },
    // ### `_writeShape` writes the shape to the output stream
    _writeNodeConstraint: function _writeNodeConstraint(v, done) {
      var _ShExWriter = this;

      try {
        _ShExWriter._expect(v, "type", "NodeConstraint");

        var pieces = [];
        if (v.nodeKind in nodeKinds) pieces.push(nodeKinds[v.nodeKind], " ");else if (v.nodeKind !== undefined) _ShExWriter._error("unexpected nodeKind: " + v.nodeKind); // !!!!

        this._fillNodeConstraint(pieces, v, done);

        this._annotations(pieces, v.annotations, "  ");

        return pieces;
      } catch (error) {
        done && done(error);
      }
    },
    _annotations: function _annotations(pieces, annotations, indent) {
      var _ShExWriter = this;

      if (annotations) {
        annotations.forEach(function (a) {
          _ShExWriter._expect(a, "type", "Annotation");

          pieces.push("//\n" + indent + "   ");
          pieces.push(_ShExWriter._encodeValue(a.predicate));
          pieces.push(" ");
          pieces.push(_ShExWriter._encodeValue(a.object));
        });
      }
    },
    _fillNodeConstraint: function _fillNodeConstraint(pieces, v, done) {
      var _ShExWriter = this;

      if (v.datatype && v.values) _ShExWriter._error("found both datatype and values in " + expr);

      if (v.datatype) {
        pieces.push(_ShExWriter._encodeShapeName(v.datatype));
      }

      if (v.values) {
        pieces.push("[");
        v.values.forEach(function (t, ord) {
          if (ord > 0) pieces.push(" ");

          if (!isTerm(t)) {
            var langOrLiteral = function langOrLiteral(t, c) {
              return ["LanguageStem", "LanguageStemRange"].indexOf(t.type) !== -1 ? "@" + c : ["LiteralStem", "LiteralStemRange"].indexOf(t.type) !== -1 ? '"' + c.replace(ESCAPE_g, c) + '"' : _ShExWriter._encodeValue(c);
            };

            //          expect(t, "type", "IriStemRange");
            if (!("type" in t)) runtimeError("expected " + JSON.stringify(t) + " to have a 'type' attribute.");
            var stemRangeTypes = ["Language", "IriStem", "LiteralStem", "LanguageStem", "IriStemRange", "LiteralStemRange", "LanguageStemRange"];
            if (stemRangeTypes.indexOf(t.type) === -1) runtimeError("expected type attribute '" + t.type + "' to be in '" + stemRangeTypes + "'.");

            if (t.type === "Language") {
              pieces.push("@" + t.languageTag);
            } else if (!isTerm(t.stem)) {
              expect(t.stem, "type", "Wildcard");
              pieces.push(".");
            } else {
              pieces.push(langOrLiteral(t, t.stem) + "~");
            }

            if (t.exclusions) {
              t.exclusions.forEach(function (c) {
                pieces.push(" - ");

                if (!isTerm(c)) {
                  //                expect(c, "type", "IriStem");
                  if (!("type" in c)) runtimeError("expected " + JSON.stringify(c) + " to have a 'type' attribute.");
                  var stemTypes = ["IriStem", "LiteralStem", "LanguageStem"];
                  if (stemTypes.indexOf(c.type) === -1) runtimeError("expected type attribute '" + c.type + "' to be in '" + stemTypes + "'.");
                  pieces.push(langOrLiteral(t, c.stem) + "~");
                } else {
                  pieces.push(langOrLiteral(t, c));
                }
              });
            }
          } else {
            pieces.push(_ShExWriter._encodeValue(t));
          }
        });
        pieces.push("]");
      }

      if ('pattern' in v) {
        var pattern = v.pattern.replace(/\//g, "\\/"); // if (ESCAPE_1.test(pattern))
        //   pattern = pattern.replace(ESCAPE_g, characterReplacer);

        var flags = 'flags' in v ? v.flags : "";
        pieces.push("/" + pattern + "/" + flags + " ");
      }

      ['length', 'minlength', 'maxlength', 'mininclusive', 'minexclusive', 'maxinclusive', 'maxexclusive', 'totaldigits', 'fractiondigits'].forEach(function (a) {
        if (v[a]) pieces.push(" ", a, " ", v[a]);
      });
      return pieces;

      function isTerm(t) {
        return typeof t !== "object" || "value" in t && Object.keys(t).reduce(function (r, k) {
          return r === false ? r : ["value", "type", "language"].indexOf(k) !== -1;
        }, true);
      }
    },
    // ### `_encodeIriOrBlankNode` represents an IRI or blank node
    _encodeIriOrBlankNode: function _encodeIriOrBlankNode(iri, trailingSpace) {
      trailingSpace = trailingSpace ? ' ' : ''; // A blank node is represented as-is

      if (iri[0] === '_' && iri[1] === ':') return iri; // Escape special characters

      if (ESCAPE_1.test(iri)) iri = iri.replace(ESCAPE_g, characterReplacer); // Try to represent the IRI as prefixed name

      var prefixMatch = this._prefixRegex.exec(iri);

      return !prefixMatch ? '<' + iri + '>' : (!prefixMatch[1] ? iri : this._prefixIRIs[prefixMatch[1]] + prefixMatch[2]) + trailingSpace;
    },
    // ### `_encodeLiteral` represents a literal
    _encodeLiteral: function _encodeLiteral(value, type, language) {
      // Escape special characters
      if (ESCAPE_1.test(value)) value = value.replace(ESCAPE_g, characterReplacer); // Write the literal, possibly with type or language

      if (language) return '"' + value + '"@' + language;else if (type) return '"' + value + '"^^' + this._encodeIriOrBlankNode(type);else return '"' + value + '"';
    },
    // ### `_encodeShapeName` represents a subject
    _encodeShapeName: function _encodeShapeName(subject, trailingSpace) {
      if (subject[0] === '"') throw new Error('A literal as subject is not allowed: ' + subject);
      return this._encodeIriOrBlankNode(subject, trailingSpace);
    },
    // ### `_encodePredicate` represents a predicate
    _encodePredicate: function _encodePredicate(predicate) {
      if (predicate[0] === '"') throw new Error('A literal as predicate is not allowed: ' + predicate);
      return predicate === RDF_TYPE ? 'a' : this._encodeIriOrBlankNode(predicate);
    },
    // ### `_encodeValue` represents an object
    _encodeValue: function _encodeValue(object) {
      // Represent an IRI or blank node
      if (typeof object !== "object") return this._encodeIriOrBlankNode(object); // Represent a literal

      return this._encodeLiteral(object.value, object.type, object.language);
    },
    // ### `_blockedWrite` replaces `_write` after the writer has been closed
    _blockedWrite: function _blockedWrite() {
      throw new Error('Cannot write because the writer has been closed.');
    },
    writeSchema: function writeSchema(shape, done) {
      this._writeSchema(shape, done);

      this.end(done);
    },
    // ### `addShape` adds the shape to the output stream
    addShape: function addShape(shape, name, done) {
      this._write(_ShExWriter._encodeShapeName(name, false) + " " + _ShExWriter._writeShapeExpr(shape, done, true, 0).join(""), done);
    },
    // ### `addShapes` adds the shapes to the output stream
    addShapes: function addShapes(shapes) {
      for (var i = 0; i < shapes.length; i++) {
        this.addShape(shapes[i]);
      }
    },
    // ### `addPrefix` adds the prefix to the output stream
    addPrefix: function addPrefix(prefix, iri, done) {
      var prefixes = {};
      prefixes[prefix] = iri;
      this.addPrefixes(prefixes, done);
    },
    // ### `addPrefixes` adds the prefixes to the output stream
    addPrefixes: function addPrefixes(prefixes, done) {
      // Add all useful prefixes
      var prefixIRIs = this._prefixIRIs,
          hasPrefixes = false;

      for (var prefix in prefixes) {
        // Verify whether the prefix can be used and does not exist yet
        var iri = prefixes[prefix];

        if ( // @@ /[#\/]$/.test(iri) && !! what was that?
        prefixIRIs[iri] !== (prefix += ':')) {
          hasPrefixes = true;
          prefixIRIs[iri] = prefix; // Write prefix

          this._write('PREFIX ' + prefix + ' <' + iri + '>\n');
        }
      } // Recreate the prefix matcher


      if (hasPrefixes) {
        var IRIlist = '',
            prefixList = '';

        for (var prefixIRI in prefixIRIs) {
          IRIlist += IRIlist ? '|' + prefixIRI : prefixIRI;
          prefixList += (prefixList ? '|' : '') + prefixIRIs[prefixIRI];
        }

        IRIlist = IRIlist.replace(/[\]\/\(\)\*\+\?\.\\\$]/g, '\\$&');
        this._prefixRegex = new RegExp('^(?:' + prefixList + ')[^\/]*$|' + '^(' + IRIlist + ')([a-zA-Z][\\-_a-zA-Z0-9]*)$');
      } // End a prefix block with a newline


      this._write(hasPrefixes ? '\n' : '', done);
    },
    // ### `_prefixRegex` matches a prefixed name or IRI that begins with one of the added prefixes
    _prefixRegex: /$0^/,
    // ### `end` signals the end of the output stream
    end: function end(done) {
      // Disallow further writing
      this._write = this._blockedWrite; // Try to end the underlying stream, ensuring done is called exactly one time

      var singleDone = done && function (error, result) {
        singleDone = null, done(error, result);
      };

      if (this._endStream) {
        try {
          return this._outputStream.end(singleDone);
        } catch (error) {
          /* error closing stream */
        }
      }

      singleDone && singleDone();
    }
  }; // Replaces a character by its escaped version

  function characterReplacer(character) {
    // Replace a single character by its escaped version
    var result = ESCAPE_replacements[character];

    if (result === undefined) {
      // Replace a single character with its 4-bit unicode escape sequence
      if (character.length === 1) {
        result = character.charCodeAt(0).toString(16);
        result = "\\u0000".substr(0, 6 - result.length) + result;
      } // Replace a surrogate pair with its 8-bit unicode escape sequence
      else {
          result = ((character.charCodeAt(0) - 0xD800) * 0x400 + character.charCodeAt(1) + 0x2400).toString(16);
          result = "\\U00000000".substr(0, 10 - result.length) + result;
        }
    }

    return result;
  }

  function escapeCode(code) {
    return code.replace(/\\/g, "\\\\").replace(/%/g, "\\%");
  }
  /** _throwError: overridable function to throw Errors().
   *
   * @param func (optional): function at which to truncate stack trace
   * @param str: error message
   */


  function _throwError(func, str) {
    if (typeof func !== "function") {
      str = func;
      func = _throwError;
    }

    var e = new Error(str);
    Error.captureStackTrace(e, func);
    throw e;
  } // Expect property p with value v in object o


  function expect(o, p, v) {
    if (!(p in o)) this._error(expect, "expected " + o + " to have a ." + p);
    if (arguments.length > 2 && o[p] !== v) this._error(expect, "expected " + o[o] + " to equal ." + v);
  } // The empty function


  function noop() {}

  return ShExWriter;
}(); // Export the `ShExWriter` class as a whole.


if (typeof require !== 'undefined' && typeof exports !== 'undefined') module.exports = ShExWriter; // node environment